import { render, staticRenderFns } from "./EternityChallengesTab.vue?vue&type=template&id=a9e94666&scoped=true&"
import script from "./EternityChallengesTab.vue?vue&type=script&lang=js&"
export * from "./EternityChallengesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e94666",
  null
  
)

export default component.exports